import { Context } from '@leverege/plugin'
import Evaluator from '../Evaluator.js'
import Expression from './Expression.js'

/**
 * Defines a satisfies class that can be tested, yielding either true, false, or null
 */
export default class ExpressionEvaluator extends Evaluator {

  static TYPE = 'condition.Expression'
  
  constructor( model, Factory ) {
    super( model, Factory )
    try {
      this.compiled = new Expression( model.expression || '' )
    } catch ( err ) { 
      console.log( err )
    }
  }

  /**
    * Determines whether the target satisfies the model is met or not given the context
    * @param {*} context The context with which the satisfies method is to be executed
    * @return {boolean or null} depending on whether the data fields are known. Null means that it is
    * unclear if the target satisfies the condition
    */
  satisfies( context ) {
    try {
      const scope = { cxt : context, target : Context.getTarget( context ) }
      let v = this.compiled && this.compiled.eval( scope )
      if ( typeof v === 'boolean' ) {
        return v
      }
      if ( Array.isArray( v ) && v.length > 0 ) {
        v = v[v.length - 1]
        if ( typeof v === 'boolean' ) {
          return v
        }
      }
    } catch ( err ) { 
      console.log( err )
    }
    return null
  }
}
